import { render } from "./HomeSlider.vue?vue&type=template&id=866bea16&scoped=true"
import script from "./HomeSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlider.vue?vue&type=script&lang=js"

import "./HomeSlider.vue?vue&type=style&index=0&id=866bea16&scoped=true&lan=scss&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866bea16"]])

export default __exports__